<template lang="pug">
    div
        Card
            div(style="text-align:center")
                h3 {{ title }}
                p {{ description }}
                p Upgrade your plan to {{ leastPlan }}
</template>
<script>
// axios.defaults.withCredentials = true;

export default {
    name: "RequireUpgrade",
    props: ["title", "description", "leastPlan"],
    data() {
        return {};
    },
    methods: {},
    mounted() {}
};
</script>

<style>
.upgradeCard {
    text-align: "center";
}
</style>



// WEBPACK FOOTER //
// src/view/general/RequireUpgrade.vue